import { PlanType } from '@showbie-socrative/socrative-utils';

import { determinePermissions } from './determinePermissions';
import { FEATURE_PERMISSION_SYMBOL } from './proCheck';
import { FeaturePermission } from './types';

export function setFeaturePermissions(
  options:
    | {
        plan: PlanType;
        userVersion?: number;
      }
    | { featurePermissions: FeaturePermission }
): FeaturePermission {
  if ('featurePermissions' in options) {
    window[FEATURE_PERMISSION_SYMBOL] = options.featurePermissions;
  } else {
    const { plan, userVersion } = options;
    window[FEATURE_PERMISSION_SYMBOL] = determinePermissions({
      plan: plan,
      userVersion: userVersion,
    });
  }

  return window[FEATURE_PERMISSION_SYMBOL];
}
